import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';
import { Display } from '@singularsystems/neo-core/dist/Model/Decorators';
import InvestorFieldConfig from './InvestorFieldConfig';
import InvestorInvestmentFieldConfig from './InvestorInvestmentFieldConfig';
import IssuerFieldConfig from './IssuerFieldConfig';
import IssuerInvestmentFieldConfig from './IssuerInvestmentFieldConfig';

export default class FieldConfigValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Display("Investors")
    @Attributes.ChildObject(InvestorFieldConfig, true)
    public investorFields: InvestorFieldConfig = new InvestorFieldConfig();

    @Display("Investor Investments")
    @Attributes.ChildObject(InvestorInvestmentFieldConfig, true)
    public investorInvestmentFields: InvestorInvestmentFieldConfig = new InvestorInvestmentFieldConfig();

    @Display("Issuers")
    @Attributes.ChildObject(IssuerFieldConfig, true)
    public issuerFields: IssuerFieldConfig = new IssuerFieldConfig();

    @Display("Issuer Investments")
    @Attributes.ChildObject(IssuerInvestmentFieldConfig, true)
    public issuerInvestmentFields: IssuerInvestmentFieldConfig = new IssuerInvestmentFieldConfig();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Field Config Values";
    }
}